module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0077.jpg?v=1166fd0e";